import React, { useState, useEffect } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';

const BOT_URL       = process.env.REACT_APP_BOT_URL || 'http://localhost:8080';
const getAdminPassword = () => sessionStorage.getItem('eco_admin_pw') || 'Ecoholic@2025';



// ── Worker Modal (Add / Edit) ────────────────────────────────────────────────
function WorkerModal({ mode, worker, locations, onClose, onSave }) {
  const isEdit = mode === 'edit';
  const availableLocs = locations && locations.length > 0 ? locations : [
    { id: 'ES3', locationName: 'Priyadarshi' },
    { id: 'ES4', locationName: 'Lekha Nagar' },
    { id: 'ES6', locationName: 'Kankarbagh' },
    { id: 'ES8', locationName: 'Exhibition Road' },
    { id: 'ES9', locationName: 'Keshari Nagar' },
    { id: 'ES10', locationName: 'Gola Road' },
    { id: 'ES12', locationName: 'Anisabad' },
    { id: 'ES13', locationName: 'Gardanibagh' },
    { id: 'ES15', locationName: 'Rajendra Nagar' },
    { id: 'ES16', locationName: 'Chitrasen Nagar' },
    { id: 'ES17', locationName: 'NTPC Colony' },
    { id: 'ES18', locationName: 'Digha' },
    { id: 'ES22', locationName: 'Sadikpur' },
    { id: 'ES23', locationName: 'Kumhrar' },
    { id: 'ES24', locationName: 'Bajrangpuri' },
    { id: 'ES25', locationName: 'Hajipur' },
    { id: 'ES27', locationName: 'Mithapur' },
    { id: 'ES32', locationName: 'Saguna More' },
    { id: 'ES35', locationName: 'IGIMS' },
    { id: 'ES38', locationName: 'Saheb' },
    { id: 'ES46', locationName: 'Khagaul' },
    { id: 'ES52', locationName: 'LT Priyadarshi' }
  ];

  const [form, setForm] = useState({
    workerId:  worker?.id       || '',
    name:      worker?.name     || '',
    phone:     worker?.phone    || '',
    locations: worker?.locations || [],
    active:    worker?.active   !== false,
  });
  const [saving, setSaving] = useState(false);
  const [error,  setError]  = useState('');

  const toggleLoc = (loc) => {
    setForm(f => ({
      ...f,
      locations: f.locations.includes(loc)
        ? f.locations.filter(l => l !== loc)
        : [...f.locations, loc]
    }));
  };

  const handleSave = async () => {
    if (!form.name.trim()) { setError('Naam required hai'); return; }
    if (!isEdit && !form.workerId.trim()) { setError('Worker ID required hai'); return; }
    if (form.locations.length === 0) { setError('Kam se kam ek location select karein'); return; }

    setSaving(true); setError('');
    try {
      let res;
      if (isEdit) {
        res = await fetch(`${BOT_URL}/admin/worker/${worker.id}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            adminPassword: getAdminPassword(),
            name:      form.name,
            phone:     form.phone,
            locations: form.locations,
            active:    form.active,
          }),
        });
      } else {
        res = await fetch(`${BOT_URL}/admin/worker`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            adminPassword: getAdminPassword(),
            workerId:  form.workerId.toUpperCase().trim(),
            name:      form.name,
            phone:     form.phone,
            locations: form.locations,
          }),
        });
      }
      const data = await res.json();
      if (data.success) { onSave(); onClose(); }
      else {
        if (res.status === 401) {
          sessionStorage.removeItem('eco_admin');
          sessionStorage.removeItem('eco_admin_pw');
          window.location.reload();
          return;
        }
        setError('❌ ' + (data.error || 'Server error'));
      }
    } catch (err) {
      setError('❌ Network error. Bot chal raha hai?');
    }
    setSaving(false);
  };

  const inp = {
    width: '100%', padding: '11px 14px',
    background: 'rgba(255,255,255,0.07)',
    border: '1px solid rgba(255,255,255,0.12)',
    borderRadius: 10, color: '#e2e8f0', fontSize: 14, outline: 'none',
    transition: 'border-color 0.2s',
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.8)',
      backdropFilter: 'blur(8px)', display: 'flex',
      alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 16,
    }} onClick={onClose}>
      <div style={{
        background: '#1a2332', border: '1px solid rgba(255,255,255,0.1)',
        borderRadius: 20, padding: 28, width: '100%', maxWidth: 520,
        maxHeight: '90vh', overflowY: 'auto',
      }} onClick={e => e.stopPropagation()}>
        {/* Header */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
          <h3 style={{ fontSize: 18, fontWeight: 700 }}>
            {isEdit ? `✏️ Edit — ${worker.id}` : '➕ Naya Worker Add Karo'}
          </h3>
          <button onClick={onClose} style={{
            background: 'rgba(255,255,255,0.07)', border: 'none',
            borderRadius: 8, width: 32, height: 32, color: '#94a3b8',
            cursor: 'pointer', fontSize: 16,
          }}>✕</button>
        </div>

        {/* Fields */}
        <div style={{ display: 'grid', gap: 16 }}>
          {!isEdit && (
            <div>
              <label style={{ display: 'block', fontSize: 12, color: '#64748b', marginBottom: 6 }}>
                Worker ID (ECO-023 format) *
              </label>
              <input
                style={inp} placeholder="ECO-023"
                value={form.workerId}
                onChange={e => setForm(f => ({ ...f, workerId: e.target.value }))}
              />
            </div>
          )}

          <div>
            <label style={{ display: 'block', fontSize: 12, color: '#64748b', marginBottom: 6 }}>
              Worker ka Naam *
            </label>
            <input
              style={inp} placeholder="Pura naam"
              value={form.name}
              onChange={e => setForm(f => ({ ...f, name: e.target.value }))}
            />
          </div>

          <div>
            <label style={{ display: 'block', fontSize: 12, color: '#64748b', marginBottom: 6 }}>
              Phone Number
            </label>
            <input
              style={inp} placeholder="10 digit mobile number"
              value={form.phone}
              onChange={e => setForm(f => ({ ...f, phone: e.target.value }))}
            />
          </div>

          <div>
            <label style={{ display: 'block', fontSize: 12, color: '#64748b', marginBottom: 10 }}>
              Location(s) Assign Karo * — {form.locations.length} selected
            </label>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 6 }}>
              {availableLocs.map(loc => (
                <button key={loc.id}
                  type="button"
                  onClick={() => toggleLoc(loc.id)}
                  style={{
                    padding: '6px 8px', borderRadius: 8, fontSize: 11, cursor: 'pointer',
                    border: form.locations.includes(loc.id)
                      ? '1px solid rgba(52,211,153,0.5)'
                      : '1px solid rgba(255,255,255,0.1)',
                    background: form.locations.includes(loc.id)
                      ? 'rgba(52,211,153,0.15)'
                      : 'rgba(255,255,255,0.04)',
                    color: form.locations.includes(loc.id) ? '#34d399' : '#94a3b8',
                    transition: 'all 0.15s', textAlign: 'left',
                  }}
                >
                  <div style={{ fontWeight: 700 }}>{loc.id}</div>
                  <div style={{ fontSize: 9, opacity: 0.7 }}>{loc.locationName}</div>
                </button>
              ))}
            </div>
          </div>

          {isEdit && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <label style={{ fontSize: 13, color: '#94a3b8' }}>Worker Status:</label>
              <button
                onClick={() => setForm(f => ({ ...f, active: !f.active }))}
                style={{
                  padding: '6px 16px', borderRadius: 8, fontSize: 13, cursor: 'pointer',
                  border: form.active ? '1px solid rgba(52,211,153,0.4)' : '1px solid rgba(248,113,113,0.4)',
                  background: form.active ? 'rgba(52,211,153,0.12)' : 'rgba(248,113,113,0.12)',
                  color: form.active ? '#34d399' : '#f87171',
                }}
              >
                {form.active ? '✅ Active' : '❌ Inactive'}
              </button>
            </div>
          )}
        </div>

        {error && (
          <div style={{
            marginTop: 16, padding: '10px 14px', borderRadius: 8,
            background: 'rgba(248,113,113,0.1)', color: '#f87171', fontSize: 13,
          }}>{error}</div>
        )}

        {/* Actions */}
        <div style={{ display: 'flex', gap: 10, marginTop: 24 }}>
          <button onClick={handleSave} disabled={saving} style={{
            flex: 1, padding: 13,
            background: saving ? 'rgba(52,211,153,0.3)' : 'linear-gradient(135deg,#34d399,#059669)',
            border: 'none', borderRadius: 10, color: '#fff',
            fontSize: 14, fontWeight: 700, cursor: saving ? 'default' : 'pointer',
          }}>
            {saving ? '⏳ Saving...' : isEdit ? '💾 Save Changes' : '➕ Add Worker'}
          </button>
          <button onClick={onClose} style={{
            padding: '13px 20px', background: 'transparent',
            border: '1px solid rgba(255,255,255,0.15)', borderRadius: 10,
            color: '#94a3b8', fontSize: 14, cursor: 'pointer',
          }}>Cancel</button>
        </div>
      </div>
    </div>
  );
}

// ── Main Workers Manager ─────────────────────────────────────────────────────
export default function WorkersManager() {
  const [workers, setWorkers]     = useState([]);
  const [locations, setLocations] = useState([]);
  const [loading, setLoading]     = useState(true);
  const [modal,   setModal]       = useState(null); // { mode: 'add'|'edit', worker? }
  const [search,  setSearch]      = useState('');
  const [filter,  setFilter]      = useState('all'); // all | active | inactive

  const fetchWorkersAndLocations = async () => {
    setLoading(true);
    try {
      // 1. Fetch workers
      const wSnap = await getDocs(collection(db, 'workers'));
      const wList = [];
      wSnap.forEach(doc => wList.push({ id: doc.id, ...doc.data() }));
      wList.sort((a, b) => a.id.localeCompare(b.id));
      setWorkers(wList);

      // 2. Fetch locations from Firestore
      const lSnap = await getDocs(collection(db, 'locations'));
      const lList = [];
      lSnap.forEach(doc => {
        const data = doc.data();
        if (data.active !== false) {
          lList.push({ id: doc.id, locationName: data.locationName || doc.id });
        }
      });
      lList.sort((a, b) => {
        const numA = parseInt((a.id || '').replace(/\D/g, '') || 0);
        const numB = parseInt((b.id || '').replace(/\D/g, '') || 0);
        return numA - numB;
      });
      setLocations(lList);
    } catch (err) { console.error(err); }
    setLoading(false);
  };

  useEffect(() => { fetchWorkersAndLocations(); }, []);

  const handleDelete = async (workerId) => {
    if (!window.confirm(`Are you sure you want to delete worker ${workerId} completely? This cannot be undone.`)) return;
    try {
      const res = await fetch(`${BOT_URL}/admin/worker/${workerId}`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          adminPassword: getAdminPassword()
        })
      });
      const data = await res.json();
      if (data.success) {
        alert("Worker deleted successfully.");
        fetchWorkersAndLocations();
      } else {
        if (res.status === 401) {
          sessionStorage.removeItem('eco_admin');
          sessionStorage.removeItem('eco_admin_pw');
          window.location.reload();
          return;
        }
        alert("❌ Error: " + (data.error || "Server error"));
      }
    } catch (err) {
      alert("❌ Error: Network error or bot server offline.");
    }
  };

  const handleDeregister = async (workerId) => {
    if (!window.confirm(`Are you sure you want to deregister Telegram for worker ${workerId}?`)) return;
    try {
      const res = await fetch(`${BOT_URL}/admin/worker/${workerId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          adminPassword: getAdminPassword(),
          registered: false,
          telegramId: null
        })
      });
      const data = await res.json();
      if (data.success) {
        alert("Worker deregistered successfully.");
        fetchWorkersAndLocations();
      } else {
        if (res.status === 401) {
          sessionStorage.removeItem('eco_admin');
          sessionStorage.removeItem('eco_admin_pw');
          window.location.reload();
          return;
        }
        alert("❌ Error: " + (data.error || "Server error"));
      }
    } catch (err) {
      alert("❌ Error: Network error or bot server offline.");
    }
  };

  const filtered = workers.filter(w => {
    const matchSearch = w.name?.toLowerCase().includes(search.toLowerCase()) ||
      w.id.toLowerCase().includes(search.toLowerCase()) ||
      (w.locations || []).some(l => l.toLowerCase().includes(search.toLowerCase()));
    const matchFilter = filter === 'all' || (filter === 'active' ? w.active !== false : w.active === false);
    return matchSearch && matchFilter;
  });

  const activeCount   = workers.filter(w => w.active !== false).length;
  const inactiveCount = workers.filter(w => w.active === false).length;

  if (loading) return (
    <div className="loading">
      <div className="spinner"></div>Workers load ho rahe hain...
    </div>
  );

  return (
    <div>
      {modal && (
        <WorkerModal
          mode={modal.mode}
          worker={modal.worker}
          locations={locations}
          onClose={() => setModal(null)}
          onSave={fetchWorkersAndLocations}
        />
      )}

      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24, flexWrap: 'wrap', gap: 12 }}>
        <div>
          <h2 style={{ fontSize: 20, fontWeight: 700, marginBottom: 4 }}>👥 Workers Manager</h2>
          <p style={{ color: '#64748b', fontSize: 13 }}>
            {activeCount} active · {inactiveCount} inactive · {workers.length} total
          </p>
        </div>
        <button onClick={() => setModal({ mode: 'add' })} style={{
          background: 'linear-gradient(135deg,#34d399,#059669)',
          border: 'none', borderRadius: 10, padding: '10px 20px',
          color: '#fff', fontSize: 14, fontWeight: 700, cursor: 'pointer',
        }}>
          ➕ Naya Worker Add Karo
        </button>
      </div>

      {/* Search + Filter */}
      <div style={{ display: 'flex', gap: 10, marginBottom: 20, flexWrap: 'wrap' }}>
        <input
          placeholder="🔍 Naam, ID, ya location dhundho..."
          value={search}
          onChange={e => setSearch(e.target.value)}
          style={{
            flex: 1, minWidth: 200, padding: '10px 14px',
            background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.12)',
            borderRadius: 10, color: '#e2e8f0', fontSize: 14, outline: 'none',
          }}
        />
        {['all', 'active', 'inactive'].map(f => (
          <button key={f}
            onClick={() => setFilter(f)}
            style={{
              padding: '10px 16px', borderRadius: 10, fontSize: 13, cursor: 'pointer',
              border: filter === f ? '1px solid rgba(52,211,153,0.4)' : '1px solid rgba(255,255,255,0.1)',
              background: filter === f ? 'rgba(52,211,153,0.12)' : 'rgba(255,255,255,0.04)',
              color: filter === f ? '#34d399' : '#94a3b8', fontWeight: filter === f ? 600 : 400,
              textTransform: 'capitalize',
            }}
          >{f}</button>
        ))}
        <button onClick={fetchWorkersAndLocations} style={{
          padding: '10px 14px', background: 'rgba(255,255,255,0.06)',
          border: '1px solid rgba(255,255,255,0.1)', borderRadius: 10,
          color: '#94a3b8', cursor: 'pointer', fontSize: 13,
        }}>🔄</button>
      </div>

      {/* Workers Table */}
      <div style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.07)', borderRadius: 14, overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr style={{ background: 'rgba(255,255,255,0.05)' }}>
              {['Worker ID', 'Naam', 'Location(s)', 'Phone', 'Telegram', 'Status', 'Actions'].map(h => (
                <th key={h} style={{ padding: '12px 16px', textAlign: 'left', color: '#64748b', fontWeight: 600, whiteSpace: 'nowrap' }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 ? (
              <tr><td colSpan={7} style={{ padding: 40, textAlign: 'center', color: '#64748b' }}>Koi worker nahi mila</td></tr>
            ) : filtered.map(w => (
              <tr key={w.id} style={{ borderTop: '1px solid rgba(255,255,255,0.04)', transition: 'background 0.1s' }}
                onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.03)'}
                onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
              >
                <td style={{ padding: '13px 16px', fontWeight: 700, color: '#60a5fa' }}>{w.id}</td>
                <td style={{ padding: '13px 16px', color: '#e2e8f0', fontWeight: 500 }}>{w.name}</td>
                <td style={{ padding: '13px 16px' }}>
                  <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
                    {(w.locations || []).map(l => (
                      <span key={l} style={{
                        padding: '2px 8px', borderRadius: 6, fontSize: 11,
                        background: 'rgba(52,211,153,0.12)', color: '#34d399', fontWeight: 600,
                      }}>{l}</span>
                    ))}
                  </div>
                </td>
                <td style={{ padding: '13px 16px', color: '#94a3b8' }}>{w.phone || '—'}</td>
                <td style={{ padding: '13px 16px' }}>
                  {w.registered ? (
                    <span style={{ color: '#34d399', fontSize: 12 }}>✅ Registered</span>
                  ) : (
                    <span style={{ color: '#64748b', fontSize: 12 }}>Not yet</span>
                  )}
                </td>
                <td style={{ padding: '13px 16px' }}>
                  <span style={{
                    padding: '3px 10px', borderRadius: 20, fontSize: 11, fontWeight: 600,
                    background: w.active !== false ? 'rgba(52,211,153,0.12)' : 'rgba(248,113,113,0.12)',
                    color: w.active !== false ? '#34d399' : '#f87171',
                  }}>
                    {w.active !== false ? 'Active' : 'Inactive'}
                  </span>
                </td>
                <td style={{ padding: '13px 16px' }}>
                  <div style={{ display: 'flex', gap: 6 }}>
                    <button
                      onClick={() => setModal({ mode: 'edit', worker: w })}
                      style={{
                        padding: '6px 12px', background: 'rgba(96,165,250,0.12)',
                        border: '1px solid rgba(96,165,250,0.25)', borderRadius: 8,
                        color: '#60a5fa', fontSize: 12, fontWeight: 600, cursor: 'pointer',
                      }}
                    >✏️ Edit</button>
                    {w.registered && (
                      <button
                        onClick={() => handleDeregister(w.id)}
                        style={{
                          padding: '6px 12px', background: 'rgba(245,158,11,0.12)',
                          border: '1px solid rgba(245,158,11,0.25)', borderRadius: 8,
                          color: '#f59e0b', fontSize: 12, fontWeight: 600, cursor: 'pointer',
                        }}
                      >🔌 Deregister</button>
                    )}
                    <button
                      onClick={() => handleDelete(w.id)}
                      style={{
                        padding: '6px 12px', background: 'rgba(248,113,113,0.12)',
                        border: '1px solid rgba(248,113,113,0.25)', borderRadius: 8,
                        color: '#f87171', fontSize: 12, fontWeight: 600, cursor: 'pointer',
                      }}
                    >🗑️ Delete</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {filtered.length > 0 && (
        <div style={{ marginTop: 12, color: '#64748b', fontSize: 12, textAlign: 'right' }}>
          {filtered.length} of {workers.length} workers shown
        </div>
      )}
    </div>
  );
}
